import React, { useEffect, useState } from "react";
import { CircularAvatar, DropDown } from "../commons";
import { entityDropDown } from "../../constant/clientDirectoryDropDown";
import {
  checkHasLowerLetter,
  checkHasNumber,
  checkHasSpecial,
  checkHasUpperLetter,
  preventEnterKey,
} from "../../utils/commonFunctions";

import {
  AuBankIcon,
  AuBankSmallIcon,
  BusinessInformationIcon,
  BusinessInformationRedIcon,
  BusinessSecurityIcon,
  BusinessSecurityRedIcon,
  CreateAccountIcon,
  PasswordSettingIcon,
  PasswordSettingRedIcon,
  PersonalInformationIcon,
  PersonalInformationRedIcon,
  ProjExelLogo,
} from "../../assets/images";
import {
  DropDownType,
  PasswordValidationType,
  UserDetailsType,
  UserProfileDetailErrorType,
} from "./AuSignUpCard";
import { HidePassword, ViewPassword } from "../Icon";
import PasswordValidationCard from "../commons/PasswordValidationCard/PasswordValidationCard";
import useDebounce from "../../customHooks/useDebounce";
import useTimerDebounce from "../../customHooks/useTimerDebounce";

type AppProps = {
  onNext: (data: any) => void;
  onPrevious: (data: any) => void;
  setUserProfileDetailsError: React.Dispatch<
    React.SetStateAction<UserProfileDetailErrorType>
  >;
  userProfileDetailsError: UserProfileDetailErrorType;

  setText: React.Dispatch<React.SetStateAction<string>>;
  setOffset: React.Dispatch<React.SetStateAction<number>>;

  limit: number;

  setTypeOfEntity: any;
  typeOfEntity: DropDownType;
  activeStep: number;

  onPasswordNext: any;
  onPasswordPrevious: any;

  inputDetails: UserDetailsType;
  setInputDetails: any;
  email: string;
  handleEmailChange: (data: any) => void;
  password: string;
  planSelected: string;
  newPassword: string;
  passwordPopUpShow: boolean;
  passwordValidation: PasswordValidationType;
  setPasswordPopUpshow: React.Dispatch<React.SetStateAction<boolean>>;
  setPasswordValidation: React.Dispatch<
    React.SetStateAction<PasswordValidationType>
  >;
  isEmail:any;
  emailMessage: null | string;
  emailFetching: boolean;
  specificPincodeInformation: any;
  dispatchGetPincodeAction: (data: any) => void;
  dispatchResetspecificPincodeInformation: () => void;
};
const BusinessDetailSecurity = ({
  onNext,
  onPrevious,
  setUserProfileDetailsError,
  userProfileDetailsError,
  planSelected,
  setText,
  setOffset,

  limit,

  setTypeOfEntity,
  typeOfEntity,
  activeStep,

  onPasswordNext,
  onPasswordPrevious,

  inputDetails,
  setInputDetails,
  email,
  handleEmailChange,
  password,
  newPassword,
  passwordPopUpShow,
  passwordValidation,
  setPasswordPopUpshow,
  setPasswordValidation,
  isEmail,
  emailMessage,
  emailFetching,
  specificPincodeInformation,
  dispatchGetPincodeAction,
  dispatchResetspecificPincodeInformation,
}: AppProps) => {
  const [businessName, setBusinessName] = useState("");
  const [noOfEmployee, setNoOfEmployee] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessAddressTwo, setBuinessAddressTwo] = useState("");
  const [haveGstRegistration, setHaveGstRegistration] = useState(false);
  const [loadCondition, setLoadCondition] = useState(true);
  const [pincode, setPincode] = useState("");
  const [countryAddress, setCountryAddress] = useState("India");
  const [stateAddress, setStateAddress] = useState("");
  const [cityAddress, setCityAddress] = useState("");

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const debouncedPincode: any = useTimerDebounce(pincode, 500);

  useEffect(() => {
    if (
      specificPincodeInformation &&
      specificPincodeInformation?.city &&
      specificPincodeInformation?.state
    ) {
      setCityAddress(specificPincodeInformation.city);
      setStateAddress(specificPincodeInformation.state);
    } else if (!debouncedPincode) {
      setCityAddress("");
      setStateAddress("");
    }
  }, [specificPincodeInformation, debouncedPincode]);

  useEffect(() => {
    if (debouncedPincode && debouncedPincode?.length === 6) {
      let finalData = {
        pincode,
      };
      dispatchGetPincodeAction(finalData);
    } else if (debouncedPincode?.length !== 6) {
      setCityAddress("");
      setStateAddress("");
    }
  }, [debouncedPincode]);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleChangeNewPassword = (e: any) => {
    setPasswordPopUpshow(true);
    let removeSpace = e?.target?.value.replace(/\s+/g, "");

    setInputDetails((prevDetails: any) => ({
      ...prevDetails,
      passworDetails: {
        ...prevDetails.passworDetails,
        password: removeSpace,
      },
    }));

    setUserProfileDetailsError((prv: any) => ({
      ...prv,
      newPasswordAgainError: "",
    }));

    let specialCharacterValue = checkHasSpecial(e.target.value);
    let uppercaseLetterValue = checkHasUpperLetter(e.target.value);
    let lowercaseLetterValue = checkHasLowerLetter(e.target.value);
    let numbercaseLetterValue = checkHasNumber(e.target.value);

    setPasswordValidation((prev: any) => ({
      ...prev,
      ...(!!specialCharacterValue && { special: true }),
      ...(!!uppercaseLetterValue && { upperCase: true }),
      ...(!!lowercaseLetterValue && { lowerCase: true }),
      ...(!!numbercaseLetterValue && { number: true }),
      ...(!!(e.target.value.length >= 8) && { atLeast: true }),
      ...(!specialCharacterValue && { special: false }),
      ...(!uppercaseLetterValue && { upperCase: false }),
      ...(!lowercaseLetterValue && { lowerCase: false }),
      ...(!numbercaseLetterValue && { number: false }),
      ...(!(e.target.value.length >= 8) && { atLeast: false }),
    }));
  };

  const steps = [
    {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,
    },
    {
      icon: AuBankSmallIcon,
      redIcon: AuBankSmallIcon,
    },
    {
      icon: BusinessSecurityIcon,
      redIcon: BusinessSecurityRedIcon,
    },
  ];

  useEffect(() => {
    let persistedData: any = localStorage.getItem("businessDetail");
    if (persistedData) {
      let parsedData = JSON.parse(persistedData);
      setBusinessName(parsedData?.businessName || "");
      setNoOfEmployee(parsedData?.noOfEmployee || "");

      setTypeOfEntity({
        value: parsedData?.value,
        label: parsedData?.label,
      });
      setBusinessAddress(parsedData?.businessAddress || "");
      setHaveGstRegistration(parsedData?.haveGstRegistration || "");
    }

    setStateAddress("");

    // setCountryAddress("");
    setCityAddress("");
  }, []);

  const handleNext = (e: any) => {
    // onNext({  businessName,
    //   businessAddress,
    //   businessAddressTwo,
    //   noOfEmployee,
    //   typeOfEntity,
    //   stateAddress,
    //   cityAddress,
    //   countryAddress,
    //   pincode});
    e.preventDefault();
    const data = {
      businessName,
      businessAddress,
      businessAddressTwo,
      noOfEmployee,
      typeOfEntity,
      stateAddress,
      cityAddress,
      countryAddress,
      pincode,
    };
    localStorage.setItem("businessDetail", JSON.stringify(data)); // Persist data
    onPasswordNext(data);
  };
  const handlePrevious = () => {
    const data = {
      businessName,
      businessAddress,
      businessAddressTwo,
      noOfEmployee,
      typeOfEntity,
      stateAddress,
      cityAddress,
      countryAddress,
      pincode,
    };
    localStorage.setItem("businessDetail", JSON.stringify(data));
    onPrevious({
      businessName,
      businessAddress,
      businessAddressTwo,
      noOfEmployee,
      typeOfEntity,
      stateAddress,
      cityAddress,
      countryAddress,
      pincode,
    });
  };
  const handleEntityChange = (data: any) => {
    setTypeOfEntity({
      value: data?.value,
      label: data?.label,
    });
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const handleChangePincode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPincode(e.target.value);
  };

  return (
    <>
      <div className="main-signup">
        <div className="business-info-container">
          <div className="logo-section mb-3 ">
            <div className="d-flex">
              <img src={ProjExelLogo} className="company-logo" />
              <img
                src={AuBankIcon}
                className="company-logo"
                style={{ height: "50px", marginLeft: "27px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "30px",
                width: "258px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {steps?.map((step, index) => (
                <>
                  <div key={index} className="step-indicator">
                    <span
                      className={`step${activeStep === index ? "active" : ""}`}
                    >
                      <img
                        src={
                          activeStep === index || activeStep > index
                            ? step?.redIcon
                            : step?.icon
                        }
                        alt={" Icon"}
                      />
                    </span>
                    <span className="line"></span>
                  </div>
                </>
              ))}
            </div>
          </div>
<h5 className="selected-plan-show">{`You have Selected ${planSelected}`}</h5>
          <h5 className="mt-4 right-panel-heading">Business Information</h5>
          <span className="right-panel-subHeading">
            Enter your details below to get started.
          </span>
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="foldername">
                  Business Name <span className="color-red">*</span>
                </label>
                <input
                  type={"text"}
                  className={"form-control mb-3"}
                  name="text"
                  value={businessName}
                  autoFocus
                  onChange={(e) => setBusinessName(e.target.value)}
                  maxLength={60}
                />
                <div className="row no-row">
                  <div className="col-md-6">
                    <label htmlFor="foldername">No of Employees</label>
                    <input
                      type={"number"}
                      className={"form-control mb-3"}
                      name="text"
                      value={noOfEmployee}
                      onChange={(e) => setNoOfEmployee(e.target.value)}
                      maxLength={60}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="foldername">Type Of Entity</label>
                    <DropDown
                      options={entityDropDown}
                      value={typeOfEntity}
                      handleChange={handleEntityChange}
                    />
                  </div>
                </div>

                <label htmlFor="foldername">
                  Address Line 1 <span className="color-red">*</span>
                </label>

                <textarea
                  className={`form-control`}
                  name="addressOne"
                  value={businessAddress}
                  onChange={(e: any) => setBusinessAddress(e.target.value)}
                  rows={2}
                  maxLength={100}
                />
                <label htmlFor="foldername">Address Line 2</label>

                <textarea
                  className={`form-control mb-3`}
                  name="addressOne"
                  value={businessAddressTwo}
                  onChange={(e: any) => setBuinessAddressTwo(e.target.value)}
                  rows={2}
                  maxLength={100}
                />

                <div className="row no-row">
                  <div className="col-md-6">
                    <label htmlFor="foldername">Pincode</label>
                    <input
                      type={"number"}
                      className={"form-control mb-3"}
                      name="text"
                      value={pincode}
                      onChange={(e) => handleChangePincode(e)}
                      maxLength={60}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="foldername">City</label>
                    <input
                      type={"text"}
                      className={"form-control mb-3"}
                      name="text"
                      value={cityAddress}
                      onChange={(e) => setCityAddress(e.target.value)}
                      maxLength={60}
                    />
                  </div>
                </div>
                <div className="row no-row">
                  <div className="col-md-6">
                    <label htmlFor="foldername">State</label>
                    <input
                      type={"text"}
                      className={"form-control mb-3"}
                      name="text"
                      value={stateAddress}
                      onChange={(e) => setStateAddress(e.target.value)}
                      maxLength={60}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="foldername">Country</label>
                    <input
                      type={"text"}
                      className={"form-control mb-3"}
                      name="text"
                      value={countryAddress}
                      // autoFocus
                      onChange={(e) => setCountryAddress(e.target.value)}
                      maxLength={60}
                      disabled
                    />
                  </div>
                </div>

                <div className="apply-voucher-parent-container">
                  <div className="apply-voucher-line"></div>
                  <span className="apply-voucher-text">
                    Set Your Password & Finish Setup
                  </span>
                  <div className="apply-voucher-line"></div>
                </div>

                <div className="password-info-container mt-0">
                  <form>
                    <div className="form-group mt-3">
                      <div>
                        <label htmlFor="foldername">
                          Email<span className="color-red">*</span>
                        </label>
                        <div style={{ position: "relative" }}>
                          <div className="row">
                            <div className="col-md-12">
                              <input
                                type={"text"}
                                className={`form-control mb-1 ${!!userProfileDetailsError?.emailError
                                    ? "error-border"
                                    : null
                                  }`}
                                name="text"
                                value={email}
                                onChange={handleEmailChange}
                                maxLength={60}
                              />
                            </div>
                          </div>
                          {emailFetching &&
                            inputDetails?.passworDetails?.email && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  right: "0",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  style={{
                                    margin: "auto",
                                    background: "none",
                                    display: "block",
                                    shapeRendering: "auto",
                                  }}
                                  width={40}
                                  height={40}
                                  viewBox="0 0 100 100"
                                  preserveAspectRatio="xMidYMid"
                                >
                                  <circle
                                    cx="50"
                                    cy="50"
                                    fill="none"
                                    stroke="#dd4433"
                                    stroke-width="5"
                                    r="20"
                                    stroke-dasharray="94.24777960769379 33.41592653589793"
                                  >
                                    <animateTransform
                                      attributeName="transform"
                                      type="rotate"
                                      repeatCount="indefinite"
                                      dur="1s"
                                      values="0 50 50;360 50 50"
                                      keyTimes="0;1"
                                    ></animateTransform>
                                  </circle>
                                </svg>
                              </div>
                            )}
                        </div>

                        {!!userProfileDetailsError?.emailError && (
                          <small className="text-danger">
                            {userProfileDetailsError?.emailError}
                          </small>
                        )}
                        {inputDetails?.passworDetails?.email &&
                          isEmail === 1 &&
                          emailMessage?.includes("email") ? (
                          <small
                            className="text-danger"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            Email is already in use!
                          </small>
                        ) : (
                          ""
                        )}
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <label>
                              Password<span className="color-red">*</span>
                            </label>
                            <div className="d-flex flex-row position-relative">
                              <input
                                style={{ paddingRight: "36px" }}
                                type={showPassword ? "text" : "password"}
                                className={`form-control mb-3 ${!!userProfileDetailsError?.newPasswordError
                                    ? "error-border"
                                    : null
                                  }`}
                                autoComplete="new-password"
                                name="password"
                                value={password}
                                onChange={(e) => {
                                  handleChangeNewPassword(e);
                                }}
                              />
                              <div
                                className="icon-box"
                                style={{ top: "7px" }}
                                onClick={toggleShowPassword}
                              >
                                {showPassword ? (
                                  <ViewPassword />
                                ) : (
                                  <HidePassword />
                                )}
                              </div>
                              {password?.length &&
                                passwordPopUpShow &&
                                Object.values(passwordValidation).includes(
                                  false
                                ) ? (
                                <PasswordValidationCard
                                  className={
                                    "tooltext-right-signup  position-absolute"
                                  }
                                  triangleClassName={
                                    "triangle-right-signup position-absolute"
                                  }
                                  isLeast={passwordValidation?.atLeast}
                                  isUpperCase={passwordValidation?.upperCase}
                                  isLowerCase={passwordValidation?.lowerCase}
                                  isSpecial={passwordValidation?.special}
                                  isNumber={passwordValidation?.number}
                                />
                              ) : (
                                ""
                              )}
                              {!!userProfileDetailsError?.newPasswordError && (
                                <small className="text-danger">
                                  {userProfileDetailsError?.newPasswordError}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <label>
                              Password Again<span className="color-red">*</span>
                            </label>
                            <div className="d-flex flex-row position-relative">
                              <input
                                style={{ paddingRight: "36px" }}
                                type={showNewPassword ? "text" : "password"}
                                className={`form-control mb-1 ${!!userProfileDetailsError?.newPasswordAgainError
                                    ? "error-border"
                                    : null
                                  }`}
                                value={newPassword}
                                onChange={(e) => {
                                  let removeSpace = e?.target?.value.replace(
                                    /\s+/g,
                                    ""
                                  );
                                  setUserProfileDetailsError((prv: any) => ({
                                    ...prv,
                                    newPasswordAgainError: "",
                                  }));
                                  setInputDetails((prevDetails: any) => ({
                                    ...prevDetails,
                                    passworDetails: {
                                      ...prevDetails.passworDetails,
                                      newPassword: removeSpace,
                                    },
                                  }));
                                }}
                              />
                              <div
                                className="icon-box"
                                style={{ top: "7px" }}
                                onClick={toggleShowNewPassword}
                              >
                                {showNewPassword ? (
                                  <ViewPassword />
                                ) : (
                                  <HidePassword />
                                )}
                              </div>
                            </div>
                            {!!userProfileDetailsError?.newPasswordAgainError && (
                              <small className="text-danger">
                                {userProfileDetailsError?.newPasswordAgainError}
                              </small>
                            )}
                          </div>
                        </div>
                        {planSelected === "Basic Plan" ? <div
                          className="mb-3 mt-3 d-flex"
                          style={{ float: "inline-start" }}
                        >
                          {<button
                            type="submit"
                            className="btn btn-outline"
                            style={{ width: "94px" }}
                            onClick={onPrevious}
                          >
                            Back
                          </button>}
                        </div> : null}

                        <div
                          className="mb-3 mt-3 d-flex"
                          style={{ float: "inline-end" }}
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "94px" }}
                            disabled={  Object.values(passwordValidation).includes(false) ||
                              !newPassword ||
                              !password ||
                              !!userProfileDetailsError?.emailError ||
                              isEmail === 1 || !businessName?.trim() || !businessAddress?.trim()}
                            onClick={handleNext}
                            // disabled={Object.values(passwordValidation).includes(false) || !newPassword ||!password || userProfileDetailsError?.emailError ||   isEmail === 1
                            // }
                            tabIndex={0}
                          >
                            Finish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </form>
          <p className="mobileCopyright copyRightBottom">
            &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
          </p>
        </div>
      </div>
    </>
  );
};

export default BusinessDetailSecurity;
